import Section from '@app/components/atoms/Section/Section'
import { toTextFieldDateFormat } from '@app/libs/format'
import { yupResolver } from '@hookform/resolvers/yup'
import { Inertia } from '@inertiajs/inertia'
import { InertiaLink } from '@inertiajs/inertia-react'
import { Button, Grid } from '@mui/material'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import BasicInformationSection from './BasicInformationSection'
import CampaignCreateSchema from './CampaignCreateSchema'
import ImageSection from './ImageSection'
import LimitSection from './LimitSection'
import LineOfCreditSection from './LineOfCreditSection'
import PartnerSection from './PartnerSection'
import TimeDisplaySection from './TimeDisplaySection'
import TimeSection from './TimeSection'

const CampaignCreate = ({ partners, status }) => {
  const { t } = useTranslation()

  const [disabled, setDisabled] = useState(false)

  const now = toTextFieldDateFormat(new Date())
  const initialValues = {
    name: '',
    description: '',
    status: 'active',
    start_at: now,
    end_at: now,
    partner_id: '',
    partner: {},
    codes_per_day: '',
    time_between_redeem: '',
    visible_from: now,
    visible_to: now,
    line_of_credit: '',
    images: [],
  }

  const {
    register,
    trigger,
    handleSubmit,
    control,
    setValue,
    setError,
    getValues,
    clearErrors,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    defaultValues: initialValues,
    resolver: yupResolver(CampaignCreateSchema),
  })

  Inertia.on('finish', () => setDisabled(false))

  const onSubmit = (data) => {
    setDisabled(true)
    Inertia.post(route('admin.campaigns.store'), data, {})
  }

  return (
    <Grid container component="form" spacing={2} onSubmit={handleSubmit(onSubmit)}>
      <Grid item xs={12}>
        <Section title={t('CAMPAIGN.BASIC_INFORMATION')}>
          <Grid container>
            <Grid item lg={7} md={12} sm={12} xs={12}>
              <BasicInformationSection
                control={control}
                errors={errors}
                getValues={getValues}
                register={register}
                setValue={setValue}
                status={status}
                trigger={trigger}
              />
            </Grid>
          </Grid>
        </Section>
      </Grid>

      <Grid item xs={12}>
        <Section title={t('CAMPAIGN.LINE_OF_CREDIT')}>
          <Grid container>
            <Grid item lg={7} md={12} sm={12} xs={12}>
              <LineOfCreditSection
                errors={errors}
                getValues={getValues}
                register={register}
                setValue={setValue}
                trigger={trigger}
              />
            </Grid>
          </Grid>
        </Section>
      </Grid>

      <Grid item xs={12}>
        <Section title={t('CAMPAIGN.PARTNER')}>
          <Grid container>
            <Grid item lg={7} md={12} sm={12} xs={12}>
              <PartnerSection
                control={control}
                errors={errors}
                getValues={getValues}
                partners={partners}
                register={register}
                setValue={setValue}
                trigger={trigger}
              />
            </Grid>
          </Grid>
        </Section>
      </Grid>

      <Grid item xs={12}>
        <Section title={t('CAMPAIGN.LIMIT')}>
          <Grid container>
            <Grid item lg={7} md={12} sm={12} xs={12}>
              <LimitSection
                errors={errors}
                getValues={getValues}
                register={register}
                setValue={setValue}
                trigger={trigger}
              />
            </Grid>
          </Grid>
        </Section>
      </Grid>
      <Grid item xs={12}>
        <Section title={t('CAMPAIGN.TIME')}>
          <Grid container>
            <Grid item lg={7} md={12} sm={12} xs={12}>
              <TimeSection errors={errors} getValues={getValues} register={register} setValue={setValue} />
            </Grid>
          </Grid>
        </Section>
      </Grid>
      <Grid item xs={12}>
        <Section title={t('CAMPAIGN.TIME_DISPLAY')}>
          <Grid container>
            <Grid item lg={7} md={12} sm={12} xs={12}>
              <TimeDisplaySection errors={errors} getValues={getValues} register={register} setValue={setValue} />
            </Grid>
          </Grid>
        </Section>
      </Grid>
      <Grid item xs={12}>
        <Section title={t('CAMPAIGN.IMAGE')}>
          <Grid container>
            <Grid item lg={7} md={12} sm={12} xs={12}>
              <ImageSection
                clearErrors={clearErrors}
                control={control}
                errors={errors}
                getValues={getValues}
                register={register}
                setError={setError}
                setValue={setValue}
              />
            </Grid>
          </Grid>
        </Section>
      </Grid>
      <Grid item xs="auto">
        <Button color="primary" disabled={disabled} type="submit" variant="contained">
          {t('BUTTON.SAVE')}
        </Button>
      </Grid>

      <Grid item xs="auto">
        <Button color="inherit" component={InertiaLink} href={route('admin.campaigns.index')} variant="contained">
          {t('BUTTON.CANCEL')}
        </Button>
      </Grid>
    </Grid>
  )
}

export default CampaignCreate
